import React from "react";
import { MdOutlineCheckCircle } from "react-icons/md";

export default function Alert({ alert, onClose }) {

    if (!alert) return null;

    return (
        <div className="fixed top-10 left-0 w-full h-full p-14 flex justify-center z-50 px-4 bg-primary-100/35 backdrop-blur-sm">

            <div className="w-full max-w-xl h-14 flex items-center justify-between
                            rounded-xl bg-secondary-50 text-gray-800 border-2 border-secondary-200 
                            px-7 py-4 shadow-lg">

                {/* Message */}
                <span className="text-sm font-medium">
                    {alert.message}
                </span>

                {/* OK Button */}
                <button
                    onClick={onClose}
                    className="flex items-center gap-1 bg-secondary-100 hover:bg-secondary-200 
                               px-4 py-2 rounded-lg text-sm font-medium transition"
                >
                    <MdOutlineCheckCircle size={18} />
                    Ok
                </button>

            </div>

        </div>
    );
}